import {
    AggregateFunctions,
    AggregateQueryInterval,
    AggregateQueryMode,
    ApiQuery,
    ApiQueryEndpoints,
    Filter,
    FilterOperators,
} from "~/modules/filters/types";
import { MEASURE_SLUGS } from "~/consts";
import {
    LegendProps,
    NavigatorControlState,
    VisualizationConfig,
    VisualizationMode,
    VisualizationModeTypes,
} from "~/modules/visualization/components/Timeseries/types";
import { TOKEN_TIMESERIES_V4_API_TOOLS_CONTROLS } from "~/modules/visualization/components/Timeseries/consts";
import { TokenTimeseriesColumns, TokenTimeseriesGroupBy } from "../types";
import { ExportTableNames } from "~/modules/downloads/types";

// // // //

const BASE_QUERY: ApiQuery = {
    sort: {
        direction: "asc",
        field: "date",
    },
    pagination: {
        page: 1,
        perPage: 25,
    },
};

const visualizationConfig: VisualizationConfig = {
    area: true,
    enableZoom: false,
    showTotal: true,
    height: 350,
    legend: {
        itemWidth: 125,
        layout: "vertical",
        align: "right",
        verticalAlign: "top",
    },
};

// // // //

export function getActiveAddressesChart(props: {
    key: string;
    description?: string;
    filters: Filter[];
    defaultGroupBy: TokenTimeseriesGroupBy;
    enableGroupByControls: boolean;
    loginRequired?: boolean;
    groupByOptions: TokenTimeseriesGroupBy[];
    groupByForceUpdate?: boolean;
    groupLimit?: number;
    legend?: LegendProps;
    navigator?: NavigatorControlState;
    height?: number;
}): VisualizationMode {
    const {
        key,
        filters,
        enableGroupByControls,
        defaultGroupBy,
        groupByOptions,
        groupByForceUpdate = true,
        loginRequired = false,
        groupLimit,
        legend = visualizationConfig.legend,
        navigator = {
            enabled: true,
            active: true,
            forceUpdate: true,
        },
        height,
    } = props;
    return {
        key,
        type: VisualizationModeTypes.column,
        loginRequired,
        content: {
            label: "Active Addresses",
        },
        visualizationConfig: {
            ...visualizationConfig,
            showTotal: false,
            legend,
            ...(height !== undefined && { height }),
        },
        visualizationControls: {
            stacked: {
                enabled: false,
                active: false,
                forceUpdate: true,
            },
            legend: {
                enabled: true,
                active: true,
                forceUpdate: true,
            },
            navigator: {
                ...navigator,
            },
        },
        endpoint: ApiQueryEndpoints.TokenTimeseriesV4,
        query: {
            ...BASE_QUERY,
            aggregate: {
                aggregateFunction: AggregateFunctions.Sum,
                groupBy: defaultGroupBy,
                interval: AggregateQueryInterval.day,
                mode: AggregateQueryMode.stock,
                groupLimit,
            },
            filter: {
                operator: FilterOperators.And,
                filters: [
                    ...filters,
                    {
                        field: TokenTimeseriesColumns.measureSlug,
                        operator: FilterOperators.Equals,
                        value: MEASURE_SLUGS.monthly_active_addresses_count,
                    },
                ],
            },
        },
        queryControls: {
            groupBy: {
                enabled: enableGroupByControls,
                forceUpdate: groupByForceUpdate,
                value: defaultGroupBy,
                allowedOptions: groupByOptions,
            },
            interval: {
                enabled: false,
                forceUpdate: true,
                value: AggregateQueryInterval.day,
                allowedOptions: [AggregateQueryInterval.day],
            },
        },
        apiTools: TOKEN_TIMESERIES_V4_API_TOOLS_CONTROLS,
        dataExportControls: {
            enabled: true,
            filename: key,
            exportTableName: ExportTableNames.token_timeseries_v4,
        },
    };
}
